import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CommercialDocument } from '../models/commercial-document';

@Injectable({
  providedIn: 'root'
})
export class CommercialDocumentService {

  constructor(private http: HttpClient) { }

  store(commercialDocument: CommercialDocument):Observable<CommercialDocument[]>{
    return this.http.post<CommercialDocument[]>('/api/commercial-document', commercialDocument);
  }

  update(commercialDocument: CommercialDocument):Observable<CommercialDocument[]>{
    return this.http.post<CommercialDocument[]>('/api/update/'+ commercialDocument.id +'/commercial-document', commercialDocument);
  }

  getDocuments(): Observable<CommercialDocument[]>{
    return this.http.get<CommercialDocument[]>('/api/get/commercial-document');
  }

  delete(commercialDocument: CommercialDocument): Observable<CommercialDocument[]>{
    return this.http.post<CommercialDocument[]>('/api/delete/' + commercialDocument.id + '/commercial-document', {});
  }

  getDocumentsByTravelID(travelID: number): Observable<CommercialDocument[]>{
    return this.http.get<CommercialDocument[]>('/api/get/travel/commercial-document', {params:{'travel_id': JSON.stringify(travelID)}});
  }
}
